import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    codigo: '',
    nombre: '',
    celular: '',
    email: '',
    pjeComision: 0,
    tipoComision: 0,
    tipoPjeComision: 0,
    pjeFeeComision: 0,
    importeComision: 0,
    observaciones: '',
    clientes: [],
    proveedores: [],
    rowVersion: null,

    vendedorDatos: [],
    vendedorClientesDatos: [],
    vendedorProveedoresDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, vendedorId) {
        state.id = vendedorId;
        state.codigo = '';
        state.nombre = '';
        state.celular = '';
        state.email = '';
        state.pjeComision = 0;
        state.tipoComision = 0;
        state.tipoPjeComision = 0;
        state.pjeFeeComision = 0;
        state.importeComision = 0;
        state.observaciones = '';
        state.clientes = [];
        state.proveedores = [];
        state.rowVersion = null;
    },
    'SET_VENDEDOR' (state, vendedor) {
        state.codigo = vendedor.codigo.trim();
        state.nombre = vendedor.nombre.trim();
        state.celular = vendedor.celular.trim();
        state.email = vendedor.email.trim();
        state.tipoComision = vendedor.tipoComision;
        state.tipoPjeComision = vendedor.tipoPjeComision;
        state.pjeComision = parseFloat(vendedor.pjeComision);
        state.pjeFeeComision = parseFloat(vendedor.pjeFeeComision);
        state.importeComision = parseFloat(vendedor.importeComision);
        state.observaciones = vendedor.observaciones.trim();
        state.clientes = vendedor.clientes.map(vendedorCliente => ({
            clienteId: vendedorCliente.clienteId,
            cliente: vendedorCliente.cliente,
            clienteNombre: vendedorCliente.cliente? vendedorCliente.cliente.nombre.trim() : null,
            clienteContactoId: vendedorCliente.clienteContactoId,
            clienteContacto: vendedorCliente.clienteContacto,
            clienteContactoNombre: vendedorCliente.clienteContacto? vendedorCliente.clienteContacto.nombre.trim() : null,
            tipoComision: vendedorCliente.tipoComision,
            tipoPjeComision: vendedorCliente.tipoPjeComision,
            pjeComision: parseFloat(vendedorCliente.pjeComision),
            pjeFeeComision: parseFloat(vendedorCliente.pjeFeeComision),
            importeComision: parseFloat(vendedorCliente.importeComision)
        })).sort((a, b) => a.clienteNombre.localeCompare(b.clienteNombre));
        state.proveedores = vendedor.proveedores;
        state.rowVersion = vendedor.rowVersion;
    },
    'ADD_PROVEEDOR'(state, proveedor) {
        let index = state.proveedores.findIndex(t => t.id == proveedor.id);
        if (index == -1) {
            state.proveedores.push({
                id: proveedor.id,
                nombre: proveedor.nombre
            });
        }
    },
    'REMOVE_PROVEEDOR'(state, proveedorId) {
        let index = state.proveedores.findIndex(t => t.id == proveedorId);
        if (index != -1) {
            state.proveedores.splice(index, 1);
        }
    },
    // 'ADD_CLIENTE'(state, params) {
    //     let index = state.clientes.findIndex(t => t.clienteId == params.clienteId 
    //         && t.clienteContactoId == params.clienteContactoId);
    //     if (index == -1) {
    //         state.clientes.push({
    //             clienteId: params.cliente? params.cliente.id : 0,
    //             cliente: params.cliente,
    //             clienteNombre: params.cliente? params.cliente.nombre.trim() : null,
    //             clienteContactoId: params.clienteContacto? params.clienteContacto.id : 0,
    //             clienteContacto: params.clienteContacto,
    //             clienteContactoNombre: params.clienteContacto? params.clienteContacto.nombre.trim() : null,
    //             tipoComision: params.tipoComision,
    //             tipoPjeComision: params.tipoPjeComision,
    //             pjeComision: params.pjeComision,
    //             pjeFeeComision: parseFloat(params.pjeFeeComision),
    //             importeComision: parseFloat(params.importeComision)
    //         });

    //         state.clientes = state.clientes.sort((a, b) => a.clienteNombre.localeCompare(b.clienteNombre))
    //     }
    // },
    'UPSERT_CLIENTE'(state, params) {
        let index = state.clientes.findIndex(t => t.clienteId == params.cliente.id 
            && t.clienteContactoId == params.clienteContacto.id);

        if (index != -1) {
            state.clientes.splice(index, 1);
        }

        state.clientes.push({
            clienteId: params.cliente? params.cliente.id : 0,
            cliente: params.cliente,
            clienteNombre: params.cliente? params.cliente.nombre.trim() : null,
            clienteContactoId: params.clienteContacto? params.clienteContacto.id : 0,
            clienteContacto: params.clienteContacto,
            clienteContactoNombre: params.clienteContacto? params.clienteContacto.nombre.trim() : null,
            tipoComision: params.tipoComision,
            tipoPjeComision: params.tipoPjeComision,
            pjeComision: params.pjeComision,
            pjeFeeComision: parseFloat(params.pjeFeeComision),
            importeComision: parseFloat(params.importeComision)
        });

        state.clientes = state.clientes.sort((a, b) => a.clienteNombre.localeCompare(b.clienteNombre));
    },    
    'REMOVE_CLIENTE'(state, params) {
        let index = state.clientes.findIndex(t => t.clienteId == params.clienteId && t.clienteContactoId == params.clienteContactoId);
        if (index != -1) {
            state.clientes.splice(index, 1);
        }
    },

    'INICIALIZAR_DATOS'(state) {
        state.vendedorDatos = [];
        state.vendedorClientesDatos = [];
        state.vendedorProveedoresDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.vendedorDatos = params.datos;
        state.vendedorClientesDatos = params.clientes;
        state.vendedorProveedoresDatos = params.proveedores;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, vendedorId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR', vendedorId);

            if (vendedorId != 0)
            {
                apiAxios.get('vendedores/' + vendedorId + '/abm' ) 
                    .then(res => {
                        commit('SET_VENDEDOR', res.data);
                        resolve()
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let pjeComision = 0;
            let pjeFeeComision = 0;
            let importeComision = 0;

            switch (state.tipoComision) {
                case 1: /* Porcentaje */
                    switch (state.tipoPjeComision) {
                        case 1: /* Porcentaje */
                            pjeComision = parseFloat(state.pjeComision);
                            break;
                    
                        case 2: /* Porcentaje Fee */
                            pjeFeeComision = parseFloat(state.pjeFeeComision);
                            break;
                    }
                    break;

                case 2: /* Importe */
                    importeComision = parseFloat(state.importeComision);
                    break;
                    
                case 3: /* Porcentaje + Importe */
                    switch (state.tipoPjeComision) {
                        case 1: /* Porcentaje */
                            pjeComision = parseFloat(state.pjeComision);
                            break;
                    
                        case 2: /* Porcentaje Fee */
                            pjeFeeComision = parseFloat(state.pjeFeeComision);
                            break;
                    }

                    importeComision = parseFloat(state.importeComision);
                    break;
            }

            let vendedor= {
                codigo: state.codigo.toUpperCase().trim(),
                nombre: state.nombre.toUpperCase().trim(),
                celular: state.celular.toUpperCase().trim(),
                email: state.email.toLowerCase().trim(),
                tipoComision: state.tipoComision,
                tipoPjeComision: state.tipoPjeComision,
                pjeComision,
                pjeFeeComision,
                importeComision,
                observaciones: state.observaciones.toUpperCase().trim(),
                clientes: state.clientes.map(item => ({
                    clienteId: item.clienteId,
                    clienteContactoId: item.clienteContactoId,
                    tipoComision: item.tipoComision,
                    tipoPjeComision: item.tipoPjeComision,
                    pjeComision: (item.tipoComision == 1 || item.tipoComision == 3) && item.tipoPjeComision == 1? parseFloat(item.pjeComision) || 0 : 0,
                    pjeFeeComision: (item.tipoComision == 1 || item.tipoComision == 3) && item.tipoPjeComision == 2? parseFloat(item.pjeFeeComision) || 0 : 0,
                    importeComision: item.tipoComision == 2 || item.tipoComision == 3? parseFloat(item.importeComision) || 0 : 0
                })),
                proveedores: state.proveedores
            }

            let url = 'vendedores';
            if (state.id != 0) {
                vendedor.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }
            apiAxios.post(url, vendedor)
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addProveedor ( { commit }, proveedor ) {
        return new Promise((resolve, reject) => {
            commit('ADD_PROVEEDOR', proveedor);
            resolve();
        })            
    },
    removeProveedor ( { commit }, proveedorId ) {
        return new Promise((resolve, reject) => {
            commit('REMOVE_PROVEEDOR', proveedorId);
            resolve();
        })            
    },
    // addCliente ( { commit }, params ) {
    //     return new Promise((resolve, reject) => {
    //         commit('ADD_CLIENTE', params);
    //         resolve();
    //     })            
    // },
    upsertCliente ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('UPSERT_CLIENTE', params);
            resolve();
        })            
    },    
    removeCliente ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('REMOVE_CLIENTE', params);
            resolve();
        })            
    },
    getDatos ( { commit }, vendedorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (vendedorId != 0) {
                apiAxios.get('vendedores/' + vendedorId) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'codigo', 'campo': 'Código', 'valor': res.data.codigo, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'celular', 'campo': 'Celular', 'valor': res.data.celular, 'formato': '' },
                            { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                        ];

                        const tipoComision = res.data.tipoComision;
                        const tipoPjeComision = res.data.tipoPjeComision;

                        switch (tipoComision) {
                            case 1: /* Porcentaje */
                                switch (tipoPjeComision) {
                                    case 1: /* Porcentaje */
                                        datos.push(
                                            { 'nombre': 'tipoComision', 'campo': 'Tipo de Comision', 'valor': 'Porcentaje', 'formato': '' },
                                            { 'nombre': 'pjeComision', 'campo': 'Pje.Comision', 'valor': res.data.pjeComision, 'formato': 'porcentaje' }
                                        );
                                        break;
                                    case 2: /* Porcentaje Fee */
                                        datos.push(
                                            { 'nombre': 'tipoComision', 'campo': 'Tipo de Comision', 'valor': 'Porcentaje Fee', 'formato': '' },
                                            { 'nombre': 'pjeFeeComision', 'campo': 'Pje.Fee como Comision', 'valor': res.data.pjeFeeComision, 'formato': 'porcentaje' }
                                        );
                                        break;
                                }
                                break;
                            
                            case 2: /* Importe */
                                datos.push(
                                    { 'nombre': 'tipoComision', 'campo': 'Tipo de Comision', 'valor': 'Importe', 'formato': '' },
                                    { 'nombre': 'importeComision', 'campo': 'Importe Comision', 'valor': res.data.importeComision, 'formato': 'moneda' }
                                );
                                break;

                            case 3: /* Porcentaje + Importe */
                                switch (tipoPjeComision) {
                                    case 1: /* Porcentaje */
                                        datos.push(
                                            { 'nombre': 'tipoComision', 'campo': 'Tipo de Comision', 'valor': 'Porcentaje Fijo + Importe', 'formato': '' },
                                            { 'nombre': 'pjeComision', 'campo': 'Pje.Comision', 'valor': res.data.pjeComision, 'formato': 'porcentaje' }
                                        );
                                        break;
                                    case 2: /* Porcentaje Fee */
                                        datos.push(
                                            { 'nombre': 'tipoComision', 'campo': 'Tipo de Comision', 'valor': 'Porcentaje Fee + Importe', 'formato': '' },
                                            { 'nombre': 'pjeFeeComision', 'campo': 'Pje.Fee como Comision', 'valor': res.data.pjeFeeComision, 'formato': 'porcentaje' }
                                        );
                                        break;
                                }
                                datos.push(
                                    { 'nombre': 'importeComision', 'campo': 'Importe Comision', 'valor': res.data.importeComision, 'formato': 'moneda' }
                                );
                                break;
                        }

                        datos.push(
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        );

                        let params = {
                            datos,
                            clientes: res.data.clientes.map(cliente => ({
                                ...cliente,
                                tipoComisionNombre: cliente.tipoComision == 1? 'Porcentaje' 
                                    : cliente.tipoComision == 2? 'Importe' 
                                    : cliente.tipoComision == 3? 'Porcentaje + Importe' : '',
                            })),
                            proveedores: res.data.proveedores
                        }
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    }    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}